/* sk-accordion.js — Info-Drawer + FAQ-Akkordeon der Produktseite (Philipp 04.11.2026, Vorbild esn.com; Analyse dispatcher/work-mp/esn-akkordeon-0411).
   ESN-Verhalten, 1:1 übernommen (nur Bedienung/Optik, keine Fremd-CI):
   1) Info-Zeilen der Kaufbox/Galeriespalte („Beschreibung“, „Anwendung“, „Zahlungsinfos“, …) öffnen KEIN Inline-Panel,
      sondern einen seitlichen Drawer (Desktop/Tablet: von rechts, Mobil: als Sheet von unten), Titel + „×“, Inhalt scrollt
      im Drawer, Seite bleibt stehen (kein Scrollsprung), Hintergrund abgedunkelt, Esc/Backdrop/× schließen, Fokus kehrt zurück.
      Gilt für: <details class="collapsible-tab"> (sections/sk-pdp-information + custom-liquid-Blöcke) und die
      Akkordeon-Zeilen von sections/sk-product-tabs ([data-sk-pacc] + [data-sk-ppanel]) – auf allen Breakpoints.
   2) FAQ/Kundenfragen (<details class="product-faq-item|sk-pq__item|sk-ptabs__faq-item">): Inline-Akkordeon wie ESN
      „Noch Fragen?“ – Höhe animiert (Web Animations API, Dauer/Easing aus assets/sk-accordion.css --sk-acc-dur/--sk-acc-ease),
      mehrere gleichzeitig offen, „+“ dreht zum „×“ (CSS), Enter/Space nativ über <summary>.
   Ohne JS: <details> bleibt nativ; sk-product-tabs-Panels zeigt .no-js per CSS. Idempotent (shopify:section:load, Section-Swap). */
(function () {
  'use strict';
  if (window.__skAccordion) return;
  window.__skAccordion = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  function cssMs(name, fb) {
    var v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    if (!v) return fb;
    return v.indexOf('ms') > -1 ? parseFloat(v) : parseFloat(v) * 1000;
  }
  function cssVal(name, fb) {
    var v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    return v || fb;
  }
  function dur(name, fb) { return reduce && reduce.matches ? 0 : cssMs(name, fb); }

  /* ---------- 1) Info-Drawer ---------- */
  var drawer = null, body = null, title = null, closeBtn = null, backdrop = null, panelEl = null, home = null, trigger = null, open = false, scrollY = 0;
  function build() {
    if (drawer) return;
    backdrop = document.createElement('div');
    backdrop.className = 'sk-idr__backdrop';
    backdrop.hidden = true;
    drawer = document.createElement('div');
    drawer.className = 'sk-idr';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-labelledby', 'sk-idr-title');
    drawer.hidden = true;
    drawer.innerHTML = '<div class="sk-idr__head"><p class="sk-idr__title" id="sk-idr-title"></p><button type="button" class="sk-idr__close" aria-label="' + (document.documentElement.lang === 'de' || !document.documentElement.lang ? 'Schließen' : 'Close') + '"><svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button></div><div class="sk-idr__body sk-rte"></div>';
    document.body.appendChild(backdrop);
    document.body.appendChild(drawer);
    body = drawer.querySelector('.sk-idr__body');
    title = drawer.querySelector('.sk-idr__title');
    closeBtn = drawer.querySelector('.sk-idr__close');
    closeBtn.addEventListener('click', close);
    backdrop.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (!open) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key === 'Tab') trap(e);
    });
  }
  function focusables() {
    return Array.prototype.filter.call(drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])'), function (el) { return el.offsetWidth || el.offsetHeight || el.getClientRects().length; });
  }
  function trap(e) {
    var f = focusables();
    if (!f.length) { e.preventDefault(); closeBtn.focus(); return; }
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  /* Scroll-Sperre: body position:fixed + top:-scrollY (wirkt auch auf iOS). Beim Lösen ZUERST Layout erzwingen (offsetHeight), sonst
     klemmt scrollTo auf die noch „fixe“ Seitenhöhe (= 0) → Sprung zum Seitenanfang (Philipp 04.11.2026, mobil gemessen: 2861 → 0). */
  function lock(on) {
    var de = document.documentElement;
    if (on) { scrollY = window.scrollY; de.classList.add('sk-idr-open'); document.body.style.top = -scrollY + 'px'; }
    else {
      de.classList.remove('sk-idr-open'); document.body.style.top = '';
      void document.body.offsetHeight;
      var prev = de.style.scrollBehavior; de.style.scrollBehavior = 'auto';
      try { window.scrollTo({ top: scrollY, left: 0, behavior: 'instant' }); } catch (_) { window.scrollTo(0, scrollY); }
      if (Math.abs(window.scrollY - scrollY) > 2) window.scrollTo(0, scrollY);
      de.style.scrollBehavior = prev;
    }
  }
  function show(trig, label, panel) {
    build();
    if (open) restore();
    trigger = trig; panelEl = panel;
    home = document.createComment('sk-idr-home');
    panel.parentNode.insertBefore(home, panel);
    body.appendChild(panel);
    panel.classList.add('sk-idr__panel');
    title.textContent = label;
    trig.setAttribute('aria-expanded', 'true');
    drawer.hidden = false; backdrop.hidden = false;
    lock(true);
    body.scrollTop = 0;
    /* Frame abwarten, dann Klasse → CSS-Transition (transform) läuft */
    requestAnimationFrame(function () { requestAnimationFrame(function () { drawer.classList.add('is-open'); backdrop.classList.add('is-open'); }); });
    open = true;
    try { closeBtn.focus({ preventScroll: true }); } catch (_) { closeBtn.focus(); }
    document.dispatchEvent(new CustomEvent('sk:drawer:open', { detail: { trigger: trig, panel: panel } }));
  }
  function restore() {
    if (!panelEl) return;
    panelEl.classList.remove('sk-idr__panel');
    if (home && home.parentNode) { home.parentNode.insertBefore(panelEl, home); home.parentNode.removeChild(home); }
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    panelEl = null; home = null;
  }
  function close() {
    if (!open) return;
    open = false;
    drawer.classList.remove('is-open'); backdrop.classList.remove('is-open');
    var t = trigger, d = dur('--sk-idr-dur', 350);
    var done = function () {
      drawer.hidden = true; backdrop.hidden = true;
      restore();
      lock(false);
      if (t) { try { t.focus({ preventScroll: true }); } catch (_) { t.focus(); } }
      trigger = null;
    };
    if (d > 0) setTimeout(done, d + 30); else done();
  }
  /* Trigger-Erkennung */
  function infoFromDetails(sum) {
    var d = sum.parentNode;
    if (!d || d.tagName !== 'DETAILS') return null;
    var panel = d.querySelector(':scope > .collapsible-tab__text');
    if (!panel) return null;
    var label = (sum.querySelector('span') || sum).textContent.trim();
    return { label: label, panel: panel, details: d };
  }
  function infoFromPtabs(btn) {
    var root = btn.closest('.sk-ptabs');
    if (!root || root.classList.contains('sk-ptabs--open')) return null;
    var id = btn.getAttribute('aria-controls');
    var panel = id ? document.getElementById(id) : null;
    if (!panel) return null;
    var label = (btn.querySelector('.sk-ptabs__acc-title') || btn).textContent.trim();
    return { label: label, panel: panel };
  }
  document.addEventListener('click', function (e) {
    var t = e.target instanceof Element ? e.target : null;
    if (!t) return;
    var sum = t.closest('details.collapsible-tab > summary.collapsible-tab__heading');
    if (sum && !sum.closest('.sk-idr')) {
      var i = infoFromDetails(sum);
      if (i) { e.preventDefault(); i.details.open = false; show(sum, i.label, i.panel); return; }
    }
    var btn = t.closest('.sk-ptabs [data-sk-pacc]');
    if (btn && !btn.closest('.sk-idr')) {
      var j = infoFromPtabs(btn);
      if (j) { e.preventDefault(); e.stopImmediatePropagation(); show(btn, j.label, j.panel); return; }
    }
  }, true);
  /* Summary-Tastatur: Enter/Space lösen nativ click aus → oben abgefangen. Ptabs-Buttons ebenso. */
  /* Variantenwechsel ersetzt [data-sk-swap]-Bereiche; ist das Panel gerade im Drawer, bleibt es dort (Panelinhalt stammt aus
     dem Haupt-Section-HTML, Kaufbox-Tabs sind nicht Teil eines Swap-Bereichs). Section-Reload im Editor → Drawer schließen. */
  document.addEventListener('shopify:section:load', function () { if (open) close(); });
  document.addEventListener('shopify:section:unload', function () { if (open) close(); });

  /* ---------- 2) FAQ-Akkordeon (details) mit Höhenanimation ---------- */
  var FAQ = 'details.product-faq-item, details.sk-pq__item, details.sk-ptabs__faq-item';
  /* Philipp 04.11.2026 (mobil „springt beim Schließen“): Kopfzeile bleibt beim Schließen an Ort und Stelle; ist sie nach oben aus dem Bild
     gescrollt (langes Panel, nach unten gescrollt, dann zu), wird sanft genau bis unter den Sticky-Header zurückgescrollt – nie zum Seitenanfang. */
  function headerOffset() {
    var top = 0;
    var cands = document.querySelectorAll('[id*="__sk-header"], .sk-header, header, [id*="__header"]');
    for (var i = 0; i < cands.length; i++) {
      var el = cands[i], n = el, depth = 0;
      while (n && n !== document.body && depth < 4) { var cs = getComputedStyle(n); if ((cs.position === 'sticky' || cs.position === 'fixed') && n.getBoundingClientRect().top <= 1) { top = Math.max(top, n.getBoundingClientRect().bottom); break; } n = n.firstElementChild; depth++; }
      if (top) break;
    }
    return Math.max(0, top) + 12;
  }
  function keepHeadVisible(sum) {
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      var r = sum.getBoundingClientRect();
      var off = headerOffset();
      if (r.top >= off) return;
      var y = window.scrollY + r.top - off;
      var smooth = !(reduce && reduce.matches);
      try { window.scrollTo({ top: Math.max(0, y), behavior: smooth ? 'smooth' : 'auto' }); } catch (_) { window.scrollTo(0, Math.max(0, y)); }
    }); });
  }
  function animDetails(d, sum) {
    var content = Array.prototype.find.call(d.children, function (c) { return c !== sum; });
    if (!content) { d.open = !d.open; return; }
    var ms = dur('--sk-acc-dur', 300), ease = cssVal('--sk-acc-ease', 'ease');
    if (d.__skAnim) { try { d.__skAnim.cancel(); } catch (_) {} }
    if (!d.open) {
      d.open = true;
      if (!ms) return;
      var h = content.getBoundingClientRect().height;
      content.style.overflow = 'hidden';
      d.__skAnim = content.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: ms, easing: ease });
      d.__skAnim.onfinish = d.__skAnim.oncancel = function () { content.style.overflow = ''; d.__skAnim = null; };
    } else {
      if (!ms) { d.open = false; keepHeadVisible(sum); return; }
      var h0 = content.getBoundingClientRect().height;
      content.style.overflow = 'hidden';
      d.__skAnim = content.animate([{ height: h0 + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: ms, easing: ease });
      d.__skAnim.onfinish = function () { d.open = false; content.style.overflow = ''; d.__skAnim = null; keepHeadVisible(sum); };
      d.__skAnim.oncancel = function () { content.style.overflow = ''; d.__skAnim = null; };
    }
  }
  document.addEventListener('click', function (e) {
    var t = e.target instanceof Element ? e.target : null;
    if (!t) return;
    var sum = t.closest('summary');
    if (!sum) return;
    var d = sum.parentNode;
    if (!d || !d.matches || !d.matches(FAQ)) return;
    if (t.closest('a,button,input,select,textarea')) return;
    if (!('animate' in content_proto())) { if (d.open) setTimeout(function () { keepHeadVisible(sum); }, 0); return; } /* alte Browser: nativ */
    e.preventDefault();
    animDetails(d, sum);
  });
  function content_proto() { return Element.prototype; }
})();
